"use strict";
import { __exports as u } from "./index.es330.js";
var a;
function f() {
  return a ? u : (a = 1, (function(s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    }), Object.defineProperty(s, "parsePath", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    function i(r) {
      const e = r.indexOf("#"), n = r.indexOf("?"), t = n > -1 && (e < 0 || n < e);
      return t || e > -1 ? {
        pathname: r.substring(0, t ? n : e),
        query: t ? r.substring(n, e > -1 ? e : void 0) : "",
        hash: e > -1 ? r.slice(e) : ""
      } : {
        pathname: r,
        query: "",
        hash: ""
      };
    }
  })(u), u);
}
export {
  f as __require
};
//# sourceMappingURL=index.es306.js.map
